module.exports = __webpack_public_path__ + "assets/img_kosher.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_kosher.png
 ** module id = 126
 ** module chunks = 1
 **/